/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

/* eslint jsx-a11y/no-static-element-interactions: 0 */
/* eslint jsx-a11y/mouse-events-have-key-events: 0 */
import React from 'react';
import classNames from 'classnames';
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Transition from 'react-transition-group/Transition';
import { ArrowRightOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

import { StyledSlider } from '../style';
import API from '../../services';
import { stringify } from '../../utils/qs';

const noop = () => {};

type OwnCaptchaSliderProps = {
  onChange?: (...args: any[]) => any;
};

type CaptchaSliderState = any;

type CaptchaSliderProps = OwnCaptchaSliderProps & typeof CaptchaSlider.defaultProps;

class CaptchaSlider extends React.PureComponent<CaptchaSliderProps, CaptchaSliderState> {
  static defaultProps = {
    onChange: noop,
  };

  bigWidth: any;
  handleWidth: any;
  onMouseMoveListener: any;
  onMouseUpListener: any;
  scale: any;
  sliderRef: any;
  sliderWidth: any;
  smallWidth: any;
  startPosition: any;
  timeout: any;

  constructor(props: CaptchaSliderProps) {
    super(props);
    this.state = {
      offset: 0,
      value: 0,
      big: undefined,
      small: undefined,
      checkedResult: undefined,
      disabled: false,
      dragging: false,
      showImages: false,
    };
  }

  componentDidMount() {
    this.getCaptchaSlide();
    this.sliderWidth = this.getWidth('slider');
    this.handleWidth = this.getWidth('handle');
  }

  getCaptchaSlide = () => {
    API.getCaptchaSlide().then((response: any) => {
      const { big, small } = response.content;
      this.setState({ big, small });
    });
  };

  checkCaptchaSlide = (value: any) => {
    API.checkCaptchaSlide(stringify({ offset: value })).then((response: any) => {
      const checkedResult = response.code === 0 && response.content !== false;

      this.setState({ checkedResult });
      if (!checkedResult) {
        setTimeout(this.reset, 1000);
      } else {
        this.props.onChange(value);
      }
    });
  };

  reset = () => {
    this.setState({
      offset: 0,
      value: 0,
      disabled: false,
      checkedResult: undefined,
    });
    this.props.onChange();
    this.getCaptchaSlide();
  };

  addDocumentEvents = (type: any) => {
    if (type === 'mouse') {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.end);
    }
  };

  removeEvents = (type: any) => {
    if (type === 'mouse') {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.end);
    }
  };

  onStart = (position: any) => {
    this.startPosition = position;
  };

  end = () => {
    this.removeEvents('mouse');
    this.checkCaptchaSlide(this.state.value);
    this.setState({ dragging: false, disabled: true });
  };

  onMouseDown = (e: any) => {
    const position = e.pageX;
    this.onStart(position);
    this.addDocumentEvents('mouse');
    e.preventDefault();
    e.stopPropagation();
  };

  onMouseMove = (e: any) => {
    const position = e.pageX;
    const diffPosition = position - this.startPosition;
    let offset = 0;
    let value = 0;

    if (diffPosition > this.sliderWidth - this.handleWidth) {
      offset = this.sliderWidth - this.handleWidth;
    } else if (diffPosition < 0) {
      offset = 0;
    } else {
      offset = diffPosition;
    }

    this.bigWidth = this.getWidth('big');
    this.smallWidth = this.getWidth('small');
    this.scale = (this.bigWidth - this.smallWidth) / (this.sliderWidth - this.handleWidth);

    value = (offset / this.sliderWidth) * 100 * this.scale;
    value = Math.round(value);
    this.setState({ offset, value, dragging: true });
  };

  onMouseEnter = () => {
    this.setImagesVisible(true);
  };

  onMouseLeave = () => {
    this.setImagesVisible(false);
  };

  setImagesVisible = (visible: any) => {
    if (visible && !this.timeout) {
      this.timeout = setTimeout(() => this.setState({ showImages: true }), 200);
      return;
    }

    if (!visible) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
      this.setState({ showImages: false });
    }
  };

  getSliderLength() {
    if (!this.sliderRef) {
      return 0;
    }

    return this.sliderRef.clientWidth;
  }

  getWidth = (name: any) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!this[`${name}Ref`]) {
      return 0;
    }
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return this[`${name}Ref`].clientWidth;
  };

  setRef = (ref: any, name: any) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    this[`${name}Ref`] = ref;
  };

  render() {
    const { offset, big, small, checkedResult, dragging, disabled, showImages } = this.state;
    const handleStyle = { left: `${offset}px` };
    const trackStyle = {
      width: offset === 0 ? 0 : `${offset + 32}px`,
      borderColor: offset === 0 ? 'transparent' : '#1283d5',
    };
    const imageStyle = {
      left: `${offset * this.scale}px`,
    };
    const mainClassName = classNames({
      'dyc-captcha-slider-main': true,
      'checked-success': checkedResult === true,
      'checked-failed': checkedResult === false,
      dragging,
    });
    let iconCode = <ArrowRightOutlined />;
    if (checkedResult === true) {
      iconCode = <CheckOutlined />;
    } else if (checkedResult === false) {
      iconCode = <CloseOutlined />;
    }

    return (
      <StyledSlider>
        <div
          className="dyc-captcha-slider"
          ref={(ref) => this.setRef(ref, 'slider')}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          <Transition in={(showImages || dragging) && !checkedResult} timeout={200}>
            {(state: any) => (
              <div className={`dyc-captcha-slider-images ${state}`}>
                <div className="images-wrapper">
                  <div>
                    <img ref={(ref) => this.setRef(ref, 'big')} className="big" src={big} alt="" />
                    <img
                      ref={(ref) => this.setRef(ref, 'small')}
                      className="small"
                      src={small}
                      style={imageStyle}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            )}
          </Transition>
          <div className={mainClassName}>
            <div className="dyc-captcha-slider-track" style={trackStyle} />
            <div
              ref={(ref) => this.setRef(ref, 'handle')}
              className="dyc-captcha-slider-handle"
              onMouseDown={disabled ? noop : this.onMouseDown}
              style={handleStyle}
            >
              {iconCode}
            </div>

            <div className="dyc-captcha-slider-tips">
              {checkedResult === undefined && !dragging && <span>按住滑块，拖动完成上方拼图</span>}
            </div>
          </div>
        </div>
      </StyledSlider>
    );
  }
}

export default CaptchaSlider;
